<template>
  <div v-if="job">
    <h1>{{job.title}}</h1>
    <p>Job id: {{ id }}</p>
    <p>{{job.details}}</p>
  </div>
  <div v-else>Loading...</div>
</template>

<script>
export default {
    data() {
        return {
            job: null
        }
    },
    props: ['id'],
    mounted() {
      fetch('http://localhost:3000/jobs/' + this.id)
        .then(res => res.json())
        .then(data => this.job = data)
        .catch(err => console.log(err.message))
    }
}
</script>

<style>

</style>